// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"68":"b7ffe8e3","126":"a3510d83","621":"6c97f94d"}[chunkId] + ".css";
};